import React, { useEffect } from 'react';
import { ScreenContainer, ContentFrame } from '@pinwheel/origami';
import { TemplateContinue } from '../../components/TemplateContinue';
import { useOpts } from '../../context';
import CircledCheckImage from '../../components/CircledCheckImage';
import useOrgName from '../../hooks/useOrgName';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { DOCUMENT_UPLOADS_SUBMIT_CACHE_KEY, useSubmitDocumentsMutation, } from '../../state/services/link-api';
import LoadingView from '../../views/Loading';
import { useAppDispatch, useAppSelector } from '../../state';
import { setError } from '../../state/slices/slice-error';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { selectStagedDocumentsByStatus } from '../../state/slices/slice-document-uploads';
import { DocumentUploadsStatus } from '../../types/document-uploads';
var DocumentUploadsSubmitted = function () {
    var _a = useOpts(), exit = _a.exit, fireClientEvent = _a.fireClientEvent;
    var getLocalizedString = useGetLocalizedString();
    var orgName = useOrgName();
    var _b = useSubmitDocumentsMutation({
        // Note: we're not making a request here, we're only accessing the request
        // results from the submit call already triggered from <DocumentUploadsList>
        fixedCacheKey: DOCUMENT_UPLOADS_SUBMIT_CACHE_KEY,
    })[1], isLoading = _b.isLoading, error = _b.error;
    var dispatch = useAppDispatch();
    var navigate = useLinkNavigate();
    var uploadedDocuments = useAppSelector(function (state) {
        return selectStagedDocumentsByStatus(state, DocumentUploadsStatus.UPLOADED);
    });
    useEffect(function () {
        if (error) {
            dispatch(setError({
                type: 'networkError',
                code: 'networkError',
                message: error.message || getLocalizedString('FAILED_TO_SUBMIT_DOCUMENTS'),
                pendingRetry: false,
            }));
            navigate('/error');
        }
    }, [dispatch, error, getLocalizedString, navigate]);
    useEffect(function () {
        if (fireClientEvent && !isLoading && !error) {
            fireClientEvent('doc_uploads_submitted', {
                uploadedDocumentsSubmittedCount: uploadedDocuments.length,
            });
        }
    }, [fireClientEvent, uploadedDocuments, isLoading, error]);
    if (isLoading) {
        return React.createElement(LoadingView, { text: getLocalizedString('SUBMITTING') });
    }
    var buttonLabel = getLocalizedString('RETURN_TO_BANKAPP', [orgName]);
    return (React.createElement(ScreenContainer, { "data-testid": "success" },
        React.createElement(ContentFrame, null,
            React.createElement(TemplateContinue, { Image: CircledCheckImage, title: getLocalizedString('DOCUMENTS_SUBMITTED'), subtitle: getLocalizedString('DOCUMENTS_SUBMITTED_FOLLOW_UP', [
                    orgName,
                ]), buttonLabel: buttonLabel, buttonEventId: "Success-exit", onContinue: function () { return exit && exit(); } }))));
};
export default DocumentUploadsSubmitted;
